import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=0823f5cf&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=0823f5cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823f5cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0823f5cf')) {
      api.createRecord('0823f5cf', component.options)
    } else {
      api.reload('0823f5cf', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=0823f5cf&scoped=true&", function () {
      api.rerender('0823f5cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PgC415szXlrN/JS/comp/DateRange.vue"
export default component.exports